import { call, put, takeLatest, delay } from 'redux-saga/effects';

import { DEBOUNCE_NOTETEXT } from './actions';
import { SAVE_DEBOUNCE_NOTETEXT } from 'Reducers/compModels/annotation/noteslat';


function* handleChange({ data:noteText }) {
  yield delay(200);
  yield put({ type: SAVE_DEBOUNCE_NOTETEXT, data: noteText });
}

function* autoSaveNoteText() {
  yield takeLatest(DEBOUNCE_NOTETEXT, handleChange);
}


export default autoSaveNoteText;
